import React, { useState } from "react";
import CursosSelect from "./cursosSelect";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../services/HttpManager";
import { ProspectCatalogs, ProspectDetails } from "../../../services/v2/prospects.service";
import { errorTexto, GENEROS } from "./salesHelpers";

interface Props {
	campusId: number;
	det: ProspectDetails;
	catalogs: ProspectCatalogs | null;
	onClose: () => void;
	onGuardado: (d: ProspectDetails) => void;
}

/** Editar los datos del cliente. Todo cambio queda en la bitácora con antes → después y quién lo hizo. */
const EditarDatos: React.FC<Props> = ({ campusId, det, catalogs, onClose, onGuardado }) => {
	const p = det.prospect;
	const [f, setF] = useState<any>({
		firstName: p.first_name || "", lastName: p.last_name || "", phone: p.phone_e164 || "", phoneAlt: p.phone_alt || "",
		email: p.email || "", genderId: p.gender_id || "", courseInterest: p.course_interest_text || "",
		campusId: p.campus_id || "", sourceId: p.source_id || "", adName: p.ad_name || "",
	});
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const set = (k: string) => (e: any) => setF({ ...f, [k]: e.target.value });

	const guardar = async () => {
		setBusy(true); setError(null);
		try {
			const r = await HttpManager.getInstance().prospectsService.update(campusId, p.id, f);
			onGuardado(r.data);
		} catch (e) { setError(errorTexto(e)); }
		finally { setBusy(false); }
	};

	return (
		<Modal show onHide={onClose} size="lg" className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Datos del cliente</Modal.Title></Modal.Header>
			<Modal.Body style={{ display: "flex", flexDirection: "column", gap: 14 }}>
				<div className="rejilla">
					<div><label htmlFor="ed-nom">Nombre</label><input id="ed-nom" value={f.firstName} onChange={set("firstName")} /></div>
					<div><label htmlFor="ed-ape">Apellidos</label><input id="ed-ape" value={f.lastName} onChange={set("lastName")} /></div>
					<div><label htmlFor="ed-tel">Teléfono (WhatsApp)</label><input id="ed-tel" type="tel" value={f.phone} onChange={set("phone")} /></div>
					<div><label htmlFor="ed-tel2">Segundo teléfono</label><input id="ed-tel2" type="tel" value={f.phoneAlt} onChange={set("phoneAlt")} placeholder="opcional" /></div>
					<div><label htmlFor="ed-mail">Correo</label><input id="ed-mail" type="email" value={f.email} onChange={set("email")} placeholder="opcional" /></div>
					<div>
						<label htmlFor="ed-gen">Género</label>
						<select id="ed-gen" value={f.genderId} onChange={set("genderId")}>
							<option value="">—</option>
							{GENEROS.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
						</select>
					</div>
					<div style={{ gridColumn: "1 / -1" }}><label htmlFor="ed-cur">Curso de interés</label><CursosSelect id="ed-cur" value={f.courseInterest} onChange={(v) => setF({ ...f, courseInterest: v })} /></div>
					<div>
						<label htmlFor="ed-pla">Plantel</label>
						<select id="ed-pla" value={f.campusId} onChange={set("campusId")}>
							<option value="">—</option>
							{(catalogs?.campuses || []).map((c) => <option key={c.id} value={c.id}>{c.name.replace("Washington Academy ", "")}</option>)}
						</select>
					</div>
					<div>
						<label htmlFor="ed-src">Cómo nos encontró</label>
						<select id="ed-src" value={f.sourceId} onChange={set("sourceId")}>
							<option value="">—</option>
							{(catalogs?.sources || []).map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
						</select>
					</div>
					<div><label htmlFor="ed-anu">Anuncio</label><input id="ed-anu" value={f.adName} onChange={set("adName")} placeholder="opcional" /></div>
				</div>
				{error ? <div className="aviso error">{error}</div> : null}
			</Modal.Body>
			<Modal.Footer>
				<button className="btn-wa" onClick={onClose}>Cancelar</button>
				<button className="btn-wa pri" disabled={busy || !f.firstName.trim()} onClick={guardar}>Guardar</button>
			</Modal.Footer>
		</Modal>
	);
};

export default EditarDatos;
